import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  let dark = theme.palette.type === "dark";
  let buttonBackground = dark
    ? "rgba(255, 255, 255, 0.22)"
    : "rgba(0, 0, 0, 0.22)";
  return {
    popup: {
      position: "absolute",
      width: "auto",
      bottom: "calc(100% + 15px)",
      zIndex: theme.zIndex.drawer + 1,
      background: theme.palette.background.paper,
      color: theme.palette.getContrastText(theme.palette.background.paper),
      border: "thin solid",
      borderColor: theme.palette.grey[dark ? 600 : 300],
      borderRadius: "4px"
    },
    toolbar:{
      display:"flex",
      flexDirection:"row",
      justifyContent:"end",
      flexWrap: "nowrap",
      backgroundColor:"lightgrey"
    },
    elemPopup:{
      display:"flex",
    },
    closeIcon: {
      cursor:"pointer"
    },
    minimizeIcon: {
      cursor:"pointer"
    },
    iconButton: {
      position: "relative",
      marginLeft: 10,
      marginRight: 5
    },
    button: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      cursor: "pointer",
      borderRadius: "4px",
      padding: "0px 3px",
      background: p => (p.opened ? buttonBackground : null),
      "&:hover": {
        cursor: p => (p.opened ? "default" : "pointer"),
        background: p =>
          p.opened ? buttonBackground : theme.palette.action.hover
      }
    },
    icon: {
      height: "0.9em",
      marginRight: 5,
      color: theme.palette.text.hint
    },
    label: {
      color: theme.palette.text.hint,
      userSelect: "none"
    }
  };
});
